import { Outlet, createRootRoute } from "@tanstack/react-router";
import { useI18n } from "../lib/i18n";
import { ErrorPage, NotFoundPage } from "../components/Status";

function RootLayout() {
  const { locale, setLocale } = useI18n();
  return (
    <>
      <Outlet />
      {/* Locale switcher fixed bottom-right — tiny, mono, unobtrusive. */}
      <div className="fixed bottom-3 right-3 font-mono text-[11px] uppercase tracking-[0.16em] text-muted">
        <button
          onClick={() => setLocale(locale === "tr" ? "en" : "tr")}
          className="ring-nexus rounded border border-border-default bg-elevated px-2 py-1 hover:text-primary"
        >
          {locale === "tr" ? "EN" : "TR"}
        </button>
      </div>
    </>
  );
}

// notFoundComponent renders on any unmatched route — TanStack Router
// invokes it as part of the root's tree, so the locale switcher is still
// available at the bottom of the 404 page. errorComponent catches
// runtime errors from any descendant route.
export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
  errorComponent: ErrorPage,
});
